import React, { useEffect, useState } from 'react';
import { lazy, Suspense } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import AuthLayout from './Layout/AuthLayout';
import Sidebar from './components/global/Sidebar';
import Topbar from './components/global/Topbar';
import Login from '../src/loginForm/LogInForm';
import Signup from '../src/loginForm/SignUpForm';
import './App.css';
import { useSelector } from 'react-redux';
import Requests from './Pages/Requests/RequestLayout';
import RedeemRequests from './Pages/Requests/RedeemRequests';
import RefundRequests from './Pages/Requests/RefundRequests';
import { TitleProvider } from './components/global/TitleContext';

const App = Component => props =>
(
    <Suspense fallback={<div>Loading...</div>}>
        <Component {...props} />
    </Suspense>
);

const Dashboard = App(lazy(() => import('./Pages/Dashboard/Dashboard')));
const ViewersList = App(lazy(() => import('./Pages/ViewersList/ViewersList')));
const AdvertisersList = App(
    lazy(() => import('./Pages/AdvertisersList/AdvertisersList'))
);
const AdApprovalList = App(
    lazy(() => import('./Pages/AdApprovalList/AdApprovalList'))
);
const AccessManagement = App(
    lazy(() => import('./Pages/AccessManagement/AccessManagement'))
);
const Support = App(lazy(() => import('./Pages/Support/SupportLayout')));
const AdvertiserSupport = App(
    lazy(() => import('./Pages/Support/AdvertiserSupport'))
);
const ViewerSupport = App(lazy(() => import('./Pages/Support/ViewerSupport')));
const SupportDetails = App(
    lazy(() => import('./Pages/Support/SupportDetails'))
);
const Tasks = App(lazy(() => import('./Pages/Tasks/Tasks')));

function Router() {
    const clientId = sessionStorage?.getItem('clientId');
    const isLoggedIn = useSelector(state => state?.emailLogin?.loginStatus);

    return (
        <>
            <TitleProvider>
                <BrowserRouter>
                    <Routes>
                        {!isLoggedIn && <Route path="/" element={<Login />} />}
                        {!isLoggedIn && (
                            <Route path="/signup" element={<Signup />} />
                        )}
                        {/* {isLoggedIn ? ( */}
                        <Route element={<AuthLayout />}>
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="ViewersList" element={<ViewersList />} />
                            <Route
                                path="advertiserslist"
                                element={<AdvertisersList />}
                            />
                            <Route
                                path="adApprovallist"
                                element={<AdApprovalList />}
                            />
                            <Route
                                path="accessmanagement"
                                element={<AccessManagement />}
                            />

                            <Route path="requests" element={<Requests />}>
                                <Route index element={<RedeemRequests />} />
                                <Route
                                    path="redeemrequests"
                                    element={<RedeemRequests />}
                                />
                                <Route
                                    path="refundrequests"
                                    element={<RefundRequests />}
                                />
                            </Route>
                            <Route path="support" element={<Support />}>
                                <Route index element={<AdvertiserSupport />} />
                                <Route
                                    path="advertisersupport"
                                    element={<AdvertiserSupport />}
                                />
                                <Route
                                    path="viewersupport"
                                    element={<ViewerSupport />}
                                />
                                {/* <Route
                                path="supportdetails/:supportId"
                                element={<SupportDetails />}
                            /> */}
                            </Route>
                            <Route
                                path="supportdetails/:supportId"
                                element={<SupportDetails />}
                            />
                            <Route path="tasks" element={<Tasks />} />
                        </Route>
                        {/* ) : (
                        <Route path="/" element={<Login />} />
                    )} */}
                    </Routes>
                </BrowserRouter>
            </TitleProvider>
        </>
    );
}

export default Router;
